// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

const getHeightVal = (aspectRatioObj, variation, isFullRowView) => {
  const { aspectRatioD } = !isEmpty(aspectRatioObj) && aspectRatioObj;
  const commonStyle = `
  height: 100%;
  min-height: calc(100% - 28px);
`;
  if (variation === 'DESKTOP' && aspectRatioD) {
    return `${commonStyle}`;
  }
  return `min-height: ${isFullRowView ? `96%` : `97%`}`;
};

export const ListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  padding-block: 20px;
  border-bottom: ${(props) => (!props.isLastItem ? '1px solid #ddd' : 'none')};
  ${(props) => (props.isLastItem ? `padding-bottom: 0;` : ``)}
  gap: 10px;
  cursor: pointer;
`;

export const ImageTag = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 16px;
  align-self: center;
  object-fit: contain;
  @media ${(props) => props.theme.mediaQuery.largeOnly} {
    width: 50px;
    height: 50px;
  }
`;

export const ItemDetails = styled.div`
  font-size: 15.5px;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  line-height: 1.5;
  justify-content: flex-start;
  height: auto;
  flex-direction: column;
  flex-grow: 1;
  display: flex;
  font-weight: 400;
  color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
  max-width: 100%;
  flex-basis: 25%;
  @media ${(props) => props.theme.mediaQuery.largeOnly} {
    font-size: 12px;
  }
`;

export const ProductName = styled.span`
  flex-basis: 25%;
  max-width: 100%;
  font-size: 15.5px;
  text-decoration: none;
  white-space: normal;
  line-height: 22px;
  text-overflow: ellipsis;
  &:hover {
    opacity: 0.5;
  }
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 1;
  flex-basis: 40%;
  max-width: 100%;
  font-size: 12px;
`;

export const ProductPrice = styled.span`
  margin-right: 10px;
  text-decoration: line-through;
  color: gray;
  font-size: 12px;
  cursor: default;
`;

export const SalesPrice = styled.span`
  font-weight: 500;
  color: #000000;
  font-size: 12px;
  &:hover {
    opacity: 0.5;
  }
`;

export const ShopNowButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  width: fit-content;
  height: fit-content;
`;

export const ButtonText = styled.span`
  text-transform: uppercase;
  font-size: 12px;
  text-decoration: underline;
  color: #000;
  padding: 4px;
  padding-left: 0;
  &:hover {
    opacity: 0.5;
  }
`;

export const ScrollContainer = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    border: 1px solid #efefef;
    ${(props) => getHeightVal(props?.aspectRatioObj, 'DESKTOP', props.isFullRowView)}
  }
  padding-inline: 10px;

  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;
